import { render, staticRenderFns } from "./CartDetails.vue?vue&type=template&id=5ac83d84&scoped=true&"
import script from "./CartDetails.vue?vue&type=script&lang=js&"
export * from "./CartDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac83d84",
  null
  
)

export default component.exports